/* Legends · Feature page — scroll motion (reveal + parallax + sticky buy bar).
   Vanilla, dependency-free, respects prefers-reduced-motion. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lafInit === '1') return;
    root.dataset.lafInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var supportsIO = 'IntersectionObserver' in window;

    /* ---- Reveal: content is visible by DEFAULT; we only hide + animate once JS is confirmed
       running, by adding .laf-reveal to the root. Toggles .is-in as elements enter / leave
       (re-triggers up & down). A safety net force-shows everything if the observer never reports
       (rare mobile stalls), so the page can never be left blank. ---- */
    var animated = [].slice.call(root.querySelectorAll('[data-laf-animate]'));
    var showAll = function () { animated.forEach(function (el) { el.classList.add('is-in'); }); };
    if (supportsIO && !reduce) {
      root.classList.add('laf-reveal');
      var seen = false;
      var revealIO = new IntersectionObserver(function (entries) {
        seen = true;
        entries.forEach(function (e) {
          e.target.classList.toggle('is-in', e.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      animated.forEach(function (el) { revealIO.observe(el); });
      // Safety: if the observer hasn't fired within 3s, drop the hide and show everything.
      window.setTimeout(function () { if (!seen) { root.classList.remove('laf-reveal'); showAll(); } }, 3000);
    } else {
      showAll();
    }

    /* ---- Parallax: gentle scroll-linked shift on product media ---- */
    if (!reduce) {
      var pxItems = [].slice.call(root.querySelectorAll('[data-laf-parallax]'));
      if (pxItems.length) {
        var ticking = false;
        var update = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          pxItems.forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) return;
            var amt = parseFloat(el.getAttribute('data-laf-parallax')) || 6;
            var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1 .. 1
            if (progress < -1) progress = -1; else if (progress > 1) progress = 1;
            el.style.transform = 'translate3d(0,' + (progress * amt).toFixed(2) + '%,0) scale(1.06)';
          });
          ticking = false;
        };
        var onScroll = function () {
          if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      }
    }

    /* ---- Sticky buy bar: appears once the hero is scrolled past ---- */
    var bar = root.querySelector('[data-laf-stickybar]');
    var hero = root.querySelector('[data-laf-hero]');
    if (bar && hero && supportsIO) {
      var barIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '-40% 0px 0px 0px' });
      barIO.observe(hero);
    }

    /* ---- Hide the theme header/menu unless we're right at the top, so it never peeks in and
       overlaps the sticky buy bar on scroll-up. Toggles a class on <html>; the page-scoped CSS
       fades .section-header out. ---- */
    var docEl = document.documentElement;
    var navTick = false;
    var navUpdate = function () {
      docEl.classList.toggle('laf-nav-hidden', (window.pageYOffset || docEl.scrollTop || 0) > 8);
      navTick = false;
    };
    var onNavScroll = function () {
      if (!navTick) { navTick = true; window.requestAnimationFrame(navUpdate); }
    };
    window.addEventListener('scroll', onNavScroll, { passive: true });
    navUpdate();
  }

  function boot() {
    document.querySelectorAll('[data-laf-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside Shopify theme editor when a section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-laf-root]');
    if (r) { r.dataset.lafInit = '0'; init(r); }
  });
})();
